<div class="pwa-install">
  Install WARP as {{platform.IOS || platform.ANDROID ? 'an app' : 'windows app'}}?
  <div class="pwa-install__buttons">
    <div class="simple-button accent" (click)="ignoreInstall()">nope</div>
    <div class="simple-button secondary" (click)="doInstall()">do it</div>
  </div>
</div>
